import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useMaterialUIController } from "context";
import CTLDialogContent from "application/components/styles/CTLDialogContent";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import MDButton from "components/MDButton";

export default function WorkingHolidayType({ onSave, openDialog, setOpenDialog }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  // state for selected type
  const [holidayType, setHolidayType] = React.useState("");

  const handleClose = () => {
    setHolidayType("");
    setOpenDialog(false);
  };

  const handleApply = () => {
    onSave(holidayType);
    handleClose();
  };

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        sx={(theme) => CTLDialogContent(theme, { darkMode })}
      >
        <DialogTitle sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          Please Select Non Working Holiday Type
        </DialogTitle>
        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <RadioGroup
            row
            name="holiday-type"
            value={holidayType}
            sx={{
              justifyContent: "center", 
              gap: 4,
              mt: 2, 
            }}
            onChange={(e) => setHolidayType(e.target.value)}
          >
            <FormControlLabel
              value="Weekly"
              control={<Radio />}
              label="Weekly"
            />
            <FormControlLabel
              value="Yearly"
              control={<Radio />}
              label="Yearly"
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton color="error" onClick={handleClose}>
            Cancel
          </MDButton>
          <MDButton
            color="success"
            onClick={handleApply}
            disabled={!holidayType}
          >
            Apply
          </MDButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
